import React, { useState, useEffect } from "react";
import axios from "axios";
import Slider from "react-slick";

const LogoSlideshow = () => {
  const [logos, setLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  const [smallestSize, setSmallestSize] = useState({ width: 100, height: 100 });

  // Fetch logos from the backend
  useEffect(() => {
    const fetchLogos = async () => {
      try {
        const response = await axios.get("https://zoomautos.co.uk/api/logos",
          {params: {
            _t: new Date().getTime(), // Add timestamp to bypass cache
          },
          }
        );
        
        const logoImages = response.data;
  
        if (logoImages.length === 0) {
          setLoading(false);
          return;
        }
  
        setLogos(logoImages);
  
        // Get the smallest logo dimensions
        const sizePromises = logoImages.flatMap((logo) =>
          logo.Image.map((img) =>
            new Promise((resolve) => {
              const image = new Image();
              image.src = img;
              image.onload = () => resolve({ width: image.width, height: image.height });
            })
          )
        );

        const sizes = await Promise.all(sizePromises);
        const minWidth = Math.min(...sizes.map((s) => s.width));
        const minHeight = Math.min(...sizes.map((s) => s.height));
  
        setSmallestSize({ width: minWidth, height: minHeight });
      } catch (error) {
        console.error("Error fetching logos:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchLogos();
  }, []);
  // Slider settings
  const sliderSettings = {
    dots: false,
    infinite: true, // Enable infinite loop
    speed: 6000, // Slow movement
    slidesToShow: Math.min(logos.length, 10), // Adjust slides dynamically
    slidesToScroll: 1, // Move one slide at a time for smooth scrolling
    autoplay: true, // Enable autoplay
    autoplaySpeed: 0, // No delay between slides
    cssEase: "linear", // Continuous scrolling effect
    arrows: false, // Hide arrows for better effect
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(logos.length, 6),
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(logos.length, 4),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(logos.length, 2),
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
    

  return (
    <div style={{ width: "80%", margin: "0 auto", textAlign: "center"}}>
  <h2 style={{ marginBottom: "10px" }} className="about-us-title">Our Clients</h2>
  <Slider {...sliderSettings}>
    {logos.map((logo, index) => (
      <div key={index} className="slide">
        {logo.Image.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Logo ${index + 1}`}
            style={{ width: "100%", height: "300px", objectFit: "contain" }}
          />
        ))}
      </div>
    ))}
  </Slider>
</div>

  );
};

export default LogoSlideshow;
